import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { API_ENDPOINTS } from '../../http/api-end-points';

@Injectable({ providedIn: 'root' })
export class DeviceRegistrationService {


    constructor(private http: HttpClient) { }

    registerDevice(token: string, installationId: string, platform = 'web') {

        const body = JSON.stringify({ fcm_token: token, platform, installation_id: installationId });

        return this.http.post(environment.baseApiUrl + API_ENDPOINTS.SYSTEM_NOTIFICATION.REGISTER_DEVICE_FCM, { payload: body });
    }

    singleReadNotification(payloadBody: any) {
        const body = JSON.stringify(payloadBody);

        return this.http.post(
            environment.workspaceApiUrl + API_ENDPOINTS.SYSTEM_NOTIFICATION.SINGLE_READ,
            { payload: body }
        );
    }


    markAllReadNotifications(payloadBody: any) {
        const body = JSON.stringify(payloadBody);

        return this.http.post(
            environment.workspaceApiUrl + API_ENDPOINTS.SYSTEM_NOTIFICATION.MARK_ALL_READ,
            { payload: body }
        );
    }

    toggleMuteNotification(payloadBody: any) {
        const body = JSON.stringify(payloadBody);

        return this.http.post(
            environment.workspaceApiUrl + API_ENDPOINTS.SYSTEM_NOTIFICATION.TOGGLE_MUTE,
            { payload: body }
        );
    }

}
